import React, { useMemo } from "react";
import ShowcaseSliderRow from "./ShowcaseSliderRow";

interface ApexProductShowcaseProps {
  config: string; // Passed from PHP as JSON string
}

const ApexProductShowcase: React.FC<ApexProductShowcaseProps> = ({
  config,
}) => {
  const parsedConfig = useMemo(() => {
    try {
      return JSON.parse(config);
    } catch (e) {
      console.error("Failed to parse ApexProductShowcase config", e);
      return [];
    }
  }, [config]);

  if (!parsedConfig || parsedConfig.length === 0) return null;

  return (
    <div className="apex-product-showcase__sliders">
      {parsedConfig.map((row: any, index: number) => (
        <ShowcaseSliderRow key={index} config={row} />
      ))}
    </div>
  );
};

export default ApexProductShowcase;
